if (!customElements.get('product-page-accordion')) {
  class ProductPageAccordion extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        titleActiveClass: 'product-info__accordion-title--active',
        descriptionHiddenClass: 'product-info__accordion-body--hidden'
      }

      this.addEventListener('click', this.toggleAccordion);
    }

    toggleAccordion(event) {
      const target = event.currentTarget;
      const accordionBody = target.nextElementSibling;

      if (target.classList.contains(this.selectors.titleActiveClass)) {
        event.currentTarget.classList.remove(this.selectors.titleActiveClass);
        accordionBody.style.height = '0px';
        accordionBody.classList.add(this.selectors.descriptionHiddenClass);
      } else {
        target.classList.add(this.selectors.titleActiveClass);
        accordionBody.style.height = `${accordionBody.scrollHeight}px`;
        accordionBody.classList.remove(this.selectors.descriptionHiddenClass);
      }
    };
  }

  customElements.define('product-page-accordion', ProductPageAccordion);
}